import { render, staticRenderFns } from "./YcoinParentRecord.vue?vue&type=template&id=49939cc6&"
import script from "./YcoinParentRecord.vue?vue&type=script&lang=js&"
export * from "./YcoinParentRecord.vue?vue&type=script&lang=js&"
import style0 from "./YcoinParentRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports